<template>
  <div id="finance-wrap">
    <div class="ss">
      <el-tabs v-model="tabsCur" @tab-click="handleChangeTabsCur">
        <el-tab-pane
          :label="item.deptName"
          :name="item.deptCode"
          v-for="(item, index) in tabs"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <div class="finance-tabs" v-if="false">
        <div
          class="item"
          :class="{
            cur: item.deptCode === tabsCur
          }"
          v-for="(item, index) in tabs"
          :key="index"
          @click="changeTabsCur(item.deptCode)"
        >
          {{ item.deptName }}
        </div>
      </div>
      <div class="secondTap" v-if="secondTaps.length">
        <div
          class="secondTap-item"
          :class="{ 'is-active': curSecondTap === item.deptCode }"
          v-for="item in secondTaps"
          :key="item.deptCode"
          @click="handleChangeSecondTap(item)"
        >
          {{ item.deptName }}
        </div>
      </div>
      <!-- 三级tap -->
      <div class="secondTap" v-if="thirdTaps.length">
        <div
          class="secondTap-item"
          :class="{ 'is-active': curThirdTap === item.deptCode }"
          v-for="item in thirdTaps"
          :key="item.deptCode"
          @click="handleChangeThirddTap(item)"
        >
          {{ item.deptName }}
        </div>
      </div>
      <!-- <el-tabs @tab-click="handleChangeTabsCur" v-if="secondTaps.length">
        <el-tab-pane
          :label="item.deptName"
          :name="item.deptCode"
          v-for="(item, index) in secondTaps"
          :key="index"
        ></el-tab-pane>
      </el-tabs> -->
      <div class="table-box">
        <!-- <el-scrollbar> -->
        <table
          class="table-item"
          width="100%"
          style="width: calc(100% + 0.25rem)"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead class="table-head">
            <tr>
              <th class="head-item">
                <span> 项目 </span>
                <el-button type="primary" @click="changeLevels(99)" size="mini" class="info-btn" v-show="levels === 1">
                  详情
                </el-button>
                <el-button type="primary" @click="changeLevels(1)" size="mini" class="info-btn" v-show="levels === 99">
                  返回
                </el-button>
              </th>
              <th class="head-item">本月预算金额(万元)</th>
              <th class="head-item">本月累计发生额(万元)</th>
              <th class="head-item">预算达成率(%)</th>
              <th class="head-item">上年同期数(万元)</th>
              <th class="head-item">同比增减(变动)</th>
              <th class="head-item">上月数(万元)</th>
              <th class="head-item">环比增减(变动)</th>
              <th class="head-item">本年累计数</th>
              <th class="head-item">年度预算达成率(%)</th>
              <th class="head-item">同期累计数</th>
              <th class="head-item">同期累计增减(变动)</th>
            </tr>
          </thead>
        </table>
        <div class="table-body-block">
          <table class="table-item" width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody class="table-body">
              <template v-for="(item, index) in tableList">
                <!-- v-if="item.levels <=levels" -->
                <!-- sumDirection -->
                <tr class="table-line" :key="index" v-if="item.levels <= levels">
                  <td class="body-lable">
                    <div class="project" v-html="item.pbusinessName"></div>
                  </td>
                  <template v-if="item.sumDirection !== 0">
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks || [], item.budgetAmount) }}
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks || [], item.amount) }}
                    </td>
                    <td class="body-lable">
                      <span>
                        <!-- :class="[
                          judgeIncreaseDecrease(item.finishRatio,item.remarks)
                        ]" -->
                        {{ judgeFinishRatio(item) }}
                      </span>
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks || [], item.rqAmount) }}
                    </td>
                    <td class="body-lable">
                      {{ Math.round(item.amountYear || 0) }}(<span
                        :class="[judgeIncreaseDecrease(item.amountYear || 0, item.remarks)]"
                        >{{ (item.amountYRatio || 0).toFixed(1) }}%</span
                      >)
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks || [], item.lastAmount) }}
                    </td>
                    <td class="body-lable">
                      {{ Math.round(item.amountMonth || 0) }}(<span
                        :class="[judgeIncreaseDecrease(item.amountMonth, item.remarks)]"
                        >{{ (item.amountMRatio || 0).toFixed(1) }}%</span
                      >)
                    </td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks || [], item.currentYearTotal) }}
                    </td>
                    <td class="body-lable">{{ judgeBudgetFinishRatio(item) }}</td>
                    <td class="body-lable">
                      {{ addCodePercentIcon(item.remarks || [], item.samePeriodTotal) }}
                    </td>
                    <td class="body-lable">
                      {{ getSamePeriod(item) }}(<span
                        :class="[judgeIncreaseDecrease(item.samePeriodTotal, item.remarks)]"
                        >{{ getSamePeriodRatio(item) }}</span
                      >)
                    </td>
                  </template>
                  <template v-else>
                    <td class="body-lable" v-for="item in 11" :key="item"></td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!-- </el-scrollbar> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
export default {
  components: {},
  props: {},
  data() {
    return {
      tabsCur: '',
      tabs: [],
      financeData: {},
      levels: 1,
      curSecondTap: '',
      curThirdTap: ''
    }
  },
  computed: {
    tableList() {
      const tap = this.curThirdTap || this.curSecondTap || this.tabsCur
      const list = this.financeData[tap]
      console.log('list: ', list)
      if (!list) return []
      for (const item of list) {
        item.amountYear = this.toPre(item.amountYear / 10000)
        item.amountMonth = this.toPre(item.amountMonth / 10000)
        item.samePeriodChange = this.toPre(item.samePeriodChange / 10000)
      }
      return list
    },
    secondTaps() {
      const target = this.tabs.find((item) => item.deptCode === this.tabsCur) || {}
      return target.childLeavesList || []
    },
    thirdTaps() {
      const target = this.secondTaps.find((item) => item.deptCode === this.curSecondTap) || {}
      return target.childLeavesList || []
    }
  },
  methods: {
    getRemarkCode(remarksLists = []) {
      const year = JSON.parse(sessionStorage.getItem('toggleDate')).time.slice(0, 4)
      let codeList = [
        '003',
        '006',
        '007',
        '008',
        '009',
        '019',
        '035',
        '046',
        '068',
        '074',
        '104',
        '124',
        '133',
        '146',
        '147',
        '148',
        '166',
        '168',
        '169'
      ]
      const newCodeList = ['003', '006', '007', '008', '009', '030', '038', '045', '056', '089', '121', '150', '151']
      const list = +year > 2023 ? newCodeList : codeList
      for (let i = 0; i < list.length; i++) {
        if (remarksLists.includes(list[i])) {
          return true
        }
      }
    },
    judgeIncreaseDecrease(value, remarks = '000') {
      const newRemarks = remarks || '000'
      let count = +value
      let className = ''
      if (this.getRemarkCode(newRemarks.split(','))) {
        className = count >= 0 ? 'green' : 'red'
      } else {
        className = count >= 0 ? 'red' : 'green'
      }
      return className
    },
    judgeFinishRatio(item) {
      let { finishRatio, productCode, budgetAmount, amount } = item
      // if (!finishRatio) return '0.0%'
      const codeList = [
        '003',
        '006',
        '007',
        '008',
        '009',
        '019',
        '035',
        '046',
        '068',
        '074',
        '104',
        '124',
        '133',
        '146',
        '147',
        '148',
        '166',
        '168',
        '169'
      ]
      budgetAmount = Number(budgetAmount) || 0
      amount = Number(amount) || 0
      if (codeList.indexOf(productCode) > -1) {
        if (!amount) return '0.0%'
        const num = (budgetAmount / amount) * 100
        return this.toPrecision(num)
      }
      if (!budgetAmount) return '0.0%'
      const num = (amount / budgetAmount) * 100
      return this.toPrecision(num)
    },
    judgeBudgetFinishRatio(item) {
      const year = JSON.parse(sessionStorage.getItem('toggleDate')).time.slice(0, 4)
      let { productCode, currentYearTotal, yearBudget, amount } = item
      // if (!finishRatio) return '0.0%'
      const codeList = [
        '003',
        '006',
        '007',
        '008',
        '009',
        '019',
        '035',
        '046',
        '068',
        '074',
        '104',
        '124',
        '133',
        '146',
        '147',
        '148',
        '166',
        '168',
        '169'
      ]
      const newCodeList = ['003', '006', '007', '008', '009', '030', '038', '045', '056', '089', '121', '150', '151']
      const list = +year > 2023 ? newCodeList : codeList
      currentYearTotal = Number(currentYearTotal) || 0
      yearBudget = Number(yearBudget) || 0
      amount = Number(amount) || 0
      if (list.indexOf(productCode) > -1) {
        // if (!amount) return '0.0%'
        // const num = (currentYearTotal / amount) * 100
        if (!yearBudget) return '0.0%'
        const num = (currentYearTotal / yearBudget) * 100
        return this.toPrecision(num)
      }
      if (!currentYearTotal) return '0.0%'
      // const num = (amount / currentYearTotal) * 100
      const num = (yearBudget / currentYearTotal) * 100
      return this.toPrecision(num)
    },
    getSamePeriod(item) {
      let { currentYearTotal, samePeriodTotal } = item
      currentYearTotal = Number(currentYearTotal) || 0
      samePeriodTotal = Number(samePeriodTotal) || 0
      if (!samePeriodTotal) return 0
      const num = currentYearTotal - samePeriodTotal
      return this.toPre(num / 10000)
    },
    getSamePeriodRatio(item) {
      let { currentYearTotal, samePeriodTotal } = item
      currentYearTotal = Number(currentYearTotal) || 0
      samePeriodTotal = Number(samePeriodTotal) || 0
      if (!samePeriodTotal) return '0.0%'
      const num = (currentYearTotal - samePeriodTotal) / samePeriodTotal
      return this.toPrecision(num, 1)
    },
    toPre(num, precision = 0) {
      const val = parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision))
      return val
    },
    toPrecision(num, precision = 1) {
      const val = parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision))
      if (val === 0) return '0.0%'
      return val + '%'
    },
    getData() {
      this.$service
        .fetch({
          url: `/api/finance-api/operation/organization?month=${JSON.parse(sessionStorage.getItem('toggleDate')).time}`
        })
        .then((res) => {
          //   console.log('res: ', res)
          this.tabs = res
          this.tabsCur = res[0].deptCode
          this.getDashboardList()
        })
    },
    // 获取看板数据
    getDashboardList() {
      this.$service
        .fetch({
          url: `/api/finance-api/operation/dashboard?month=${JSON.parse(sessionStorage.getItem('toggleDate')).time}`
        })
        .then((res) => {
          console.log('res-getDashboardList: ', res)
          this.financeData = res.financeBoards
        })
    },
    checkToken(val) {
      let mobile = JSON.parse(val).mobile
      this.$service
        .fetch({
          url: `/api/finance/getFinanceMobileList`
        })
        .then((res) => {
          if (res.includes(mobile)) {
            this.getData()
          } else {
            this.$alert('您无权限访问该页面！', '提示', {
              confirmButtonText: '确定'
            }).then(({ value }) => {
              this.$router.push({ path: `/` })
            })
          }
        })
        .catch(() => {
          this.$router.push({ path: `/` })
        })
    },
    changeLevels(level) {
      this.levels = level
    },
    changeTabsCur(value) {
      this.tabsCur = value
      this.changeLevels(1)
    },
    handleChangeTabsCur() {
      console.log('this.tabsCur: ', this.tabsCur)
      // 清空二级tap
      this.curSecondTap = ''
      // 清空三级tap
      this.curThirdTap = ''
      this.changeLevels(1)
    },
    handleChangeSecondTap(item) {
      this.curSecondTap = item.deptCode
      this.curThirdTap = ''
      this.changeLevels(1)
    },
    handleChangeThirddTap(item) {
      this.curThirdTap = item.deptCode
      // 清空三级tap
      this.changeLevels(1)
    },
    addCodePercentIcon(remarksLists = [], value = '') {
      const year = JSON.parse(sessionStorage.getItem('toggleDate')).time.slice(0, 4)
      let codeList = ['005', '007', '169', '171', '146']
      const newCodeList = ['005', '007', '128', '151', '153']
      const list = +year > 2023 ? newCodeList : codeList
      let newValue = Number(value) / 10000
      for (let i = 0; i < list.length; i++) {
        if (remarksLists.includes(list[i])) {
          let num = +newValue
          return `${num.toFixed(1)}%`
        }
      }
      return Math.round(newValue)
    }
  },
  created() {
    this.getData()
    // let token = window.localStorage.getItem('token')
    // if (token) {
    //   this.checkToken(Base64.decode(token.split('.')[1]))
    // }
  }
}
</script>
<style lang="scss" scoped>
#finance-wrap {
  width: 100%;
  .secondTap {
    display: flex;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    margin-top: 10px;
    gap: 15px;
    &-item {
      color: #fff;
      cursor: pointer;
      padding: 0 16px;
      text-align: center;
      &.is-active {
        background: #007eff;
      }
    }
  }
  /deep/ .el-tabs__header {
    height: 50px;
    line-height: 50px;
    background: #1c1839;
    border-radius: 10px;
    margin-bottom: 0;
  }
  /deep/ .el-tabs__nav.is-top {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
  }
  /deep/ .el-tabs__item.is-top {
    flex: 1;
    text-align: center;
  }
  /deep/ .el-tabs__nav-prev,
  /deep/.el-tabs__nav-next {
    font-size: 24px;
    line-height: 50px;
  }
  /deep/ .el-tabs__active-bar {
    background-color: transparent;
  }
  /deep/ .el-tabs__item {
    padding: 0 16px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    &.is-active {
      background: #007eff;
    }
  }
  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
}
</style>
<style lang="stylus" scoped>
.finance-tabs
  background #1c1839
  line-height 50px
  height 50px
  border-radius 10px
  overflow hidden
  white-space nowrap
  padding-left 12px
  flex-shrink: 0
  display: flex
  .item
    flex: 1
    display inline-block
    padding 0 5px
    font-size 13px
    color #fff
    text-align center
    cursor pointer
    vertical-align top
  .cur
    background #007eff
.table-box
  background #1c1839
  border-radius 10px
  margin-top 10px
  text-align center
  // height 1080px
  flex-grow: 1
  &::-webkit-scrollbar
      width: 0.75rem;
      height: 0.75rem;
      background-color: #F5F5F5;
  &::-webkit-scrollbar-track
      box-shadow: inset 0 0 0.375rem #999;
      border-radius: 0.625rem;
      background-color: #F5F5F5;
  &::-webkit-scrollbar-thumb
      border-radius: 0.625rem;
      box-shadow: inset 0 0 0.375rem #999;
      background-color: #333;
  .table-body-block
    width calc(100% + 1rem)
    box-sizing: border-box
    height: calc(100vh - 190px)
    overflow: auto
    &::-webkit-scrollbar
      width: 0.75rem;
      height: 0.75rem;
      background-color: #F5F5F5;
    &::-webkit-scrollbar-track
        box-shadow: inset 0 0 0.375rem #999;
        border-radius: 0.625rem;
        background-color: #F5F5F5;
    &::-webkit-scrollbar-thumb
        border-radius: 0.625rem;
        box-shadow: inset 0 0 0.375rem #999;
        background-color: #333;
  .table-head
    background #1f1e44
    height 40px
    color #fff
    position: sticky
    top: 0
    .head-item
      width 8%
      border-right 1px solid #44426e
      font-size 14px
      position relative
      height: 2rem
    .head-item:last-child
      border none 0
    .head-item:first-child
      padding-left 20px
      text-align left
      width calc(25% - 20px)
  .table-line
    height 36px
    line-height 24px
    padding 6px 0
    color rgba(255,255,255,0.6)
    font-size 13px
    .body-lable
      border-right 1px solid #343146
      border-bottom 1px solid #343146
      width :8%
      .project
        padding-left 20px
        padding-right 6px
        text-align left
      .subproject
        padding-left 30px
        text-align left
    .body-lable:first-child
        width: calc(25% - 20px);
    .body-lable:last-child
      border-right none 0
  .table-line:last-child .body-lable
    border-bottom none 0
.table-item
  border-bottom: 1px solid #44426e
#finance-wrap
  //height 100%
  //overflow: hidden
  flex-grow: 1
  overflow:auto
  >>> .el-scrollbar
        height 100%
        .el-scrollbar__wrap
          overflow-x: hidden

.info-btn
  position: absolute;
  right: 10px;
  top 5px

.ss
  height: 100%
  width calc(100% - 1rem)
  display: flex;
  flex-direction: column;

.body-lable
  .red
    color: red
  .green
    color: green
</style>
